// src/pwa/pages/BookPwa.jsx
import React, { useEffect, useState } from 'react';

// import { Link } from 'react-router-dom';

import '../styles/pwa.css';
// import InstallGuide from '../components/InstallGuide';
import FooterPwa from '../components/FooterPwa';
import { allocateNextSlot,cancelReservation } from '../../firebase/callFunctions';

import LoadingCard from '../../shared/components/LoadingCard';
import ClosedCard  from '../../shared/components/ClosedCard';
import ReservedCard from '../../shared/components/ReservedCard';

// import { isStandalone, isIOS, isAndroid } from '../utils/pwaEnv';
import usePwaAuth from '../hooks/usePwaAuth';
import usePublicQueue from '../../shared/hooks/usePublicQueue';

import { db } from '../../firebase/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

import PushTokenBanner from '../components/PushTokenBanner';
import { usePwaPushToken } from '../hooks/usePwaPushToken';


export default function BookPwa() {

    // const showDebug =
    // (import.meta?.env?.MODE !== 'production') ||
    // new URLSearchParams(window.location.search).get('dbg') === '1' ||
    // localStorage.getItem('pwa_dbg') === '1';


  // --- インストール状態 & プラットフォーム ---
  // const [installed, setInstalled] = useState(isStandalone());
  // const [platform]  = useState(isIOS() ? 'ios' : (isAndroid() ? 'android' : 'other'));
  // const [deferredPrompt, setDeferredPrompt] = useState(null);
  // 予約ボタンの状態
  const [busyReserve, setBusyReserve] = useState(false);
  const [reserveError, setReserveError] = useState('');
  

  // =========================
  // 0) PWA呼び出し判定
  // =========================
  // useEffect(() => {
  //   const onVis = () => setInstalled(isStandalone());
  //   const onInstalled = () => setInstalled(true);
  //   document.addEventListener('visibilitychange', onVis);
  //   window.addEventListener('appinstalled', onInstalled);

  //   // Android の beforeinstallprompt を保持（InstallGuide で使える）
  //   const onBIP = (e) => { e.preventDefault(); setDeferredPrompt(e); };
  //   window.addEventListener('beforeinstallprompt', onBIP);

  //   return () => {
  //     document.removeEventListener('visibilitychange', onVis);
  //     window.removeEventListener('appinstalled', onInstalled);
  //     window.removeEventListener('beforeinstallprompt', onBIP);
  //   };
  // }, []);



  // =========================
  // 1) uid（usePwaAuth）判定
  // =========================
  const { uid, error: authError } = usePwaAuth();
  // usePwaAuth() の戻り uid が undefined → 判定中
  const authReady = uid !== undefined;
  
  //WEB-PUSH用変数
  const { permission, needAction, busy, reason, requestAndRegister } = usePwaPushToken(uid);



  // =========================
  // 2) ランタイム購読（usePublicQueue）
  // =========================
  const queue = usePublicQueue({
    userId: uid ?? null,
    userIdField: 'pwaId',  // ← 実スキーマに合わせて変更OK
    enabled: true,          // runtimeは常に購読
  });


  // =========================
  // 3) 自予約ウォッチ（onSnapshot）
  // =========================
  const [resv, setResv] = useState(null);      // { no, slotId, at, ... } or null
  const [resvReady, setResvReady] = useState(false); // 初回到着フラグ
  const [busyCancel, setBusyCancel] = useState(false);


  useEffect(() => {
    // ユーザー切替で初期化
    setResv(null);
    setResvReady(false);

    if (!uid) return; // uid が未確定(null/undefined)なら購読しない

    // 予約コレクション内の「自分の待機中」のみ購読
    const q = query(
      collection(db, 'reservation_slots'),
      where('pwaId', '==', uid),       
      where('isReserved', '==', true),
      where('canceled', '==', false),
      where('isReceptionAccepted', '==', false),
      where('canceledPwaAt', '==', null)
      
    );

    const unsub = onSnapshot(q, { includeMetadataChanges: true }, (snap) => {
      const fromCache = snap.metadata.fromCache === true;

      if (snap.empty) {
        // キャッシュ由来の空は無視し、サーバー応答を待つ
        if (fromCache) return;
        setResv(null);
        setResvReady(true);
        return;
      }

      // 複数持っていた場合は最小番号を採用
      let best = null;
      snap.forEach((docSnap) => {
        const d = docSnap.data();
        const no = Number(d?.reservationNumber ?? 1e9);
        if (!best || no < Number(best?.reservationNumber ?? 1e9)) {
          best = { id: docSnap.id, ...d };
        }
      });

      if (!best) {
        setResv(null);
        setResvReady(true);
        return;
      }

      const atMs = best.reservedAt?.toMillis ? best.reservedAt.toMillis() : Date.now();
      setResv({
        no: best.reservationNumber,
        slotId: best.id,
        by: uid,
        reservedType: best.reservedType || 'PWA',
        at: atMs,
      });
      setResvReady(true);
    }, (err) => {
      console.error('[PWA] reservation watch error', err);
      setResv(null);
      setResvReady(true);
    });

    return () => unsub();
  }, [uid]);

  const handleReserve = async () => {
    if (!uid) return;                 // 念のため（UIでも無効化しています）
    if (busyReserve) return;
    setBusyReserve(true);
    setReserveError('');

    try {
      // PWA予約として番号確保
      const data = await allocateNextSlot({ reservedType: 'PWA' });
      if (!data?.ok) throw new Error('番号の確保に失敗しました。');

      // 予約確保に成功すると Functions 側で Firestore へ書き込み → あなたの onSnapshot が拾って resv が入る想定
      // もし即時に画面を切り替えたいなら setResv してもOK:
      // setResv({ no: data.reservationNumber, slotId: data.id, by: uid, reservedType: 'PWA', at: Date.now() });

    } catch (e) {
      const code = e?.code; // "failed-precondition" | "resource-exhausted" | "aborted" など
      let msg = e?.message || '受付番号の確保に失敗しました。時間をおいて再度お試しください。';
      if (code === 'failed-precondition') {
        msg = '現在オンライン受付を停止中です。時間をおいて再度お試しください。';
      } else if (code === 'resource-exhausted') {
        msg = '空き番号がありません。しばらくしてから再試行してください。';
      } else if (code === 'aborted') {
        msg = '混み合っています。もう一度お試しください。';
      }
      setReserveError(msg);
      // alert(msg);
    } finally {
      setBusyReserve(false);
    }
  };


  // ---- 予約キャンセルボタン ----
  const handleInPwaCancel = async () => {
    if (!resv) return;
    setBusyCancel(true);
    try {
      await cancelReservation({
        slotId: resv.slotId,
        reservationNumber: resv.no,
        canceledBy: "PWA",
      });
      setResv(null); // ← これで予約カードを閉じて通常画面に戻る
    } catch (e) {
      alert(e?.message || '予約の取消に失敗しました。');
    } finally {
      setBusyCancel(false);
    }
  };


  // =========================
  // 4) ロード中の判定（まずは LoadingCard を出す動作確認）
  // =========================
  const loading =
    (uid === undefined) ||               // ① uid 取得中（usePwaAuth）
    (!queue.runtimeReady) ||             // ② ランタイム未確定（usePublicQueue）
    (queue.inhouseOn === true && !queue.rowsReady) || // ③ 受付ON時は一覧の初回到着待ち
    (!!uid && !resvReady);               // ④ uidが確定したら自予約到着まで待つ

  
  
    // ---- 未インストール → ガイドをそのまま表示 ----
  // if (!installed) {
  //   return (
  //     <InstallGuide
  //       platform={platform}
  //       deferredPrompt={deferredPrompt}
  //       onDidInstall={() => setInstalled(true)}
  //     />
  //   );
  // }


  if (authError) {
    return (
      <div className="line-container">
        <div className="line-card">
          <h1 className="line-title">認証エラー</h1>
          <p className="line-desc">{String(authError.message || authError)}</p>
        </div>
      </div>
    );
  }

  // —— ここでまずは「LoadingCardが出るか」テスト —— //
  if (loading) {
    return (
      <div className="line-container">
        <LoadingCard />
      </div>
    );
  }



  // =========================
  // 5) ローディング明けの分岐（この段階では表示だけ・後で中身を作る）
  // =========================

  // // ランタイム（院内受付 = inhouseOn）が false → 閉鎖
  if (queue.inhouseOn === false) {
    return (
      <div className="line-container">
        <ClosedCard />
        <FooterPwa />
      </div>
    );
  }


  // 自予約あり → ReservedCard（※本番で myAheadCount などを渡す想定）
  if (resv) {
    return (
      <div className="line-container">
        <ReservedCard
          resv={resv}
          myAheadCount={queue.myAheadCount ?? null}
          displayName={""}                      
          onCancel={handleInPwaCancel}
          cancelBusy={busyCancel}
        />
        <FooterPwa />
      </div>
    );
  }
  
  // // ランタイム（オンライン受付 = isOnlineOpen）が false → 閉鎖
  if (queue.isOnlineOpen === false) {
    return (
      <div className="line-container">
        <ClosedCard />
        <FooterPwa />
      </div>
    );
  }

  // 初期表示
  return (
    <div className="line-container">
      <div className="line-card">
        <div className="line-wait">
          <div className="line-wait-caption">現在の待ち人数</div>
          <div className="line-wait-count">
            {queue.waitCount == null ? '—' : `${queue.waitCount}人`}
          </div>
        </div>

        <p className="line-desc">
          院内でも診察の順番受付を承っています。来院時には必ず受付番号をスタッフまでお知らせください。
          この受付番号は中待合に入るまでの順番になります。お呼びする順番は前後する場合があります。
        </p>

        <button
          className="line-primary-btn line-primary-btn--xl"
          onClick={handleReserve}
          disabled={!(authReady && !!uid) || busyReserve || !!resv}
        >
          { !authReady
            ? '認証を確認しています…'
            : !uid
              ? 'PWA認証中です'
              : busyReserve
                ? '予約番号を確保しています…'
                : '受付番号予約'
          }
        </button>

        {/* WEB-PUSH通知ボタン*/}
        { needAction && <PushTokenBanner busy={busy} needAction={needAction} onClick={requestAndRegister} reason={reason} /> }

        {reserveError && (
          <p className="line-error" role="alert" aria-live="assertive">{reserveError}</p>
        )}
        
        <div className="line-muted" style={{marginTop:12}}>
          uid: {uid}
        </div>
      </div>

      <FooterPwa />  

    </div>
  );
}